// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { RapidReviewCarePlanItemResponse } from './rapid-review-care-plan-item-response';

/** See com.rev360.pms.api.controller.encounter.rapidreview.RapidReviewDiagnosisResponse */
/* istanbul ignore next */
@GandalfModel
export class RapidReviewDiagnosisResponse extends GandalfModelBase {

	@GandalfArray(RapidReviewCarePlanItemResponse)
	carePlanItems!: RapidReviewCarePlanItemResponse[];

	@GandalfProperty({ designType: String })
	code!: string;

	@GandalfConstantDecorator(constants.CodeSet)
	@GandalfProperty({ designType: constants.CodeSet })
	codeSet!: constants.CodeSet;

	@GandalfProperty({ designType: String })
	description!: string;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	diagnosisDate!: Date;

	@GandalfConstantDecorator(constants.DiagnosisLocation)
	@GandalfProperty({ designType: constants.DiagnosisLocation })
	location!: constants.DiagnosisLocation | null;

	@GandalfProperty({ designType: Number })
	personDiagnosisId!: number;

}
